import { jsx as _jsx } from "react/jsx-runtime";
import { Decorative } from "@faire/design-tokens";
import { ExclusivityDetailsLink } from "@faire/retailer-visitor-shared/features/Exclusivity/DetailsModal/ExclusivityDetailsLink";
import { Span } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
export var ExclusivityLink = function(param) {
    var agreementToken = param.agreementToken, brandToken = param.brandToken, origin = param.origin;
    return /*#__PURE__*/ _jsx(ExclusivityDetailsLink, {
        agreementToken: agreementToken,
        brandToken: brandToken,
        origin: origin,
        color: Decorative.shade.orange,
        children: /*#__PURE__*/ _jsx(Span, {
            color: "inherit",
            variant: {
                mobileAndAbove: "labelSansMedium",
                desktopAndAbove: "paragraphSansMedium"
            },
            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "G1RbuN",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Exclusivity"
                    }
                ]
            })
        })
    });
};
